/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint no-unused-vars: "off"*/
import React, { useEffect, useState, useRef } from "react";
import loadJS from "load-js";
import { Button, Spin } from "antd";
import { getLastDomByClassName } from "../../../utils";
import usePortal from "react-useportal";
import "./useRMateChart.scss";
import { StyledButton } from "../../../styled-components/Button";
import { TI_CHART_BUTTON, TI_MODAL_RESULT_CLOSE_BUTTON, TI_SHOW_CHART_BUTTON } from "../../../Constants";

const useRMateChart = ({ init, each_chart_js, children, disabled, style }) => {
  const chartProfile = window.CHART_PROFILE || "dev";
  const [visible, setVisible] = useState(false);

  const [isInit, setIsInit] = useState(false);

  useEffect(() => {
    let chartUrlList = [
      `/js/chart/LicenseKey/${chartProfile}/rMateChartH5License.js`,
      "/js/chart/rMateIntegrationH5.js",
    ];
    if (each_chart_js) chartUrlList.push(each_chart_js);

    loadJS(chartUrlList).then(() => {
      init();
      setIsInit(true);
      setClickedObject(children);
    });
  }, []);

  useEffect(() => {
    setVisible(disabled);
  }, [disabled]);

  const [clickedObject, setClickedObject] = useState();

  // Pie 차트 무한로딩 문제로 투명도와, 보이지 않을 때 zIndex 값을 음수로 설정합니다.
  const visibility = {
    opacity: 0,
    zIndex: -1,
  };

  const { Portal } = usePortal({
    bindTo: getLastDomByClassName("toolbar-show-chart"),
  });

  const showChartButtonRef = useRef(null);
  const closeButtonRef = useRef(null);

  return (
    <>
      <Portal>
        <StyledButton
          tabIndex={TI_SHOW_CHART_BUTTON}
          onClick={() => {
            setVisible(!visible);
            setTimeout(() => {
              if (closeButtonRef.current) {
                closeButtonRef.current.focus();
              }
            }, 300);
          }}
          disabled={disabled}
          isActive={!visible}
          ref={showChartButtonRef}
        >
          차트 보기
        </StyledButton>
      </Portal>

      <div
        style={
          visible ? { ...visibility, ...CHART_CONTAINER_STYLE } : { ...CHART_CONTAINER_STYLE, zIndex: 1, ...style }
        }
        className={"rmate-chart-pane"}
      >
        <StyledButton
          ref={closeButtonRef}
          style={{
            position: "absolute",
            top: 10,
            right: 5,
            zIndex: 20,
          }}
          tabIndex={TI_MODAL_RESULT_CLOSE_BUTTON}
          onClick={() => {
            setTimeout(() => {
              if (showChartButtonRef.current) {
                showChartButtonRef.current.focus();
              }
            }, 300);
            setVisible(true);
          }}
        >
          닫기
        </StyledButton>
        {/* <Button
          style={STYLE_CLOSE}
          hidden={visible}
          shape="circle"
          icon={"close"}
          onClick={() => setVisible(true)}
        /> */}
        {!isInit && <Spin style={{ position: "absolute", left: "50%", top: "50%", zIndex: 1 }} size={"large"} />}
        {isInit && children}
      </div>
    </>
  );
};

const CHART_CONTAINER_STYLE = {
  position: "absolute",
  padding: "4px",
  margin: "8px",
  background: "rgba(255, 255, 255, 1)",
  right: 36,
  top: 76,
  width: "600px",
  height: "auto",
  maxHeight: "540px",
  overflowX: "auto",
  overflowY: "auto",
  border: "1px solid grey",
};

const STYLE_CLOSE = {
  position: "absolute",
  top: 10,
  right: 5,
  padding: "4px",
  zIndex: 20,
};

export default useRMateChart;
